import { SystemAdminLogin, SystemAdminVerify, SystemAdminModify, SystemAdminInsert, SystemAdminDelete, SystemAdminUpdate, SystemAdminGetById, SystemAdminGetList, SystemAdminGetPageList } from "@/api/systemadmin/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 登录
    SystemAdminLogin(context, payload) {
        return new Promise((resolve, reject) => {
            SystemAdminLogin({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 验证
    SystemAdminVerify(context, payload) {
        return new Promise((resolve, reject) => {
            SystemAdminVerify({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 修改
    SystemAdminModify(context, payload) {
        return new Promise((resolve, reject) => {
            SystemAdminModify({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    SystemAdminInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            SystemAdminInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemAdminUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemAdminUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemAdminGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemAdminGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemAdminGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemAdminGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemAdminGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemAdminGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}